// ФОНОВЫЕ ФОТО САЙТА — всё в одном месте.
//
// Как поменять фото:
//   1. Положи новый файл в папку src/assets/site/
//   2. Замени имя файла в нужной строке ниже (или просто перезапиши старый файл
//      тем же именем — тогда правки в коде вообще не нужны).
//   3. Перезапусти фронтенд: docker compose restart frontend (или npm start).
//
// Рекомендации: JPG, ширина ~2000px, вес до ~400 КБ (иначе сайт грузится долго,
// особенно с телефона). Фото горизонтальные, широкие — они обрезаются по высоте.
//
// Фото туров и услуг сюда НЕ входят — их менеджер загружает через админку.

import heroImage from "src/assets/site/hero.jpg";
import pageTopImage from "src/assets/site/page-top.jpg";
import activitiesImage from "src/assets/site/activities.jpg";
import bottomImage from "src/assets/site/bottom.jpg";

export const SITE_IMAGES = {
  // Главный экран на "/" (самый верх сайта, за заголовком)
  hero: heroImage,
  // Шапка внутренних страниц: /activities, /services, /write-review
  pageTop: pageTopImage,
  // Фон блока туров на главной (секция #activities)
  activities: activitiesImage,
  // Низ сайта — фон футера (на всех страницах)
  bottom: bottomImage,
};


// ═══════════════════════════════════════════════════════════════════════════
//  ФОНЫ ОТДЕЛЬНЫХ СЕКЦИЙ — НЕОБЯЗАТЕЛЬНЫЕ
// ═══════════════════════════════════════════════════════════════════════════
//
// Между блоками главной страницы («Япония за шесть карточек», «Частые
// вопросы», «С чего начать», «О нас») фон ровный тёмный. Если хочется, чтобы
// за каким-то блоком стояла фотография — это делается БЕЗ программиста:
//
//   1. Положи файл в папку `public/backgrounds/`
//      (папка уже создана; JPG, ширина ~2000 px, вес до ~400 КБ).
//   2. Впиши его имя в строку нужного блока ниже, начиная со слэша:
//         about: "/backgrounds/about.jpg",
//   3. Обнови страницу. Пересобирать ничего не нужно.
//
// Пустая строка "" — фона нет, блок остаётся тёмным, как сейчас.
// ВАЖНО ПРО КАДР: фотография всегда закрывает блок целиком, а блоки широкие и
// низкие, поэтому у обычного снимка 3:2 срезается верх и низ. Чтобы фон не
// выглядел обрезанным, кладите панорамные кадры — примерно 2:1 и шире
// (например 2000×1000). Подробнее — в src/sections/components/section-backdrop.jsx.
// Фотография сама растворяется по краям и уходит под тёмную вуаль, так что
// текст поверх неё остаётся читаемым. Плотность вуали — PHOTO_VEIL ниже.
// Там, где фото нет, блок не остаётся плоско-тёмным: под ним рисуется мягкое
// тёплое свечение (section-backdrop.jsx). Так что убрать любой из фонов —
// нормальный рабочий вариант, а не «дырка».
export const SECTION_IMAGES = {
  // ── «О нас» ──────────────────────────────────────────────────────────────
  // Вид из дома на осенний сад: «мы смотрим на Японию изнутри» — ровно то,
  // о чём текст блока. Замена: положи свой файл рядом и впиши его имя.
  about: "/backgrounds/about.jpg",

  // ── «Япония за шесть карточек» ───────────────────────────────────────────
  // Ханами на канале: люди, фонари, повседневная Япония — блок как раз про
  // быт и этикет. Раньше здесь стоял временный кадр из подвала.
  tips: "/backgrounds/tips.jpg",

  // ── «Частые вопросы» ─────────────────────────────────────────────────────
  // Тории в тумане: холодный спокойный кадр с большим пустым полем — под
  // блоком, который снимает тревогу покупателя, и текст на нём не спорит.
  faq: "/backgrounds/faq.jpg",

  // ── «С чего начать» — четыре карточки-развилки перед подвалом ────────────
  // Улица Хигасияма к пагоде: буквально дорога — тот же смысл, что у блока.
  explore: "/backgrounds/explore.jpg",
};

// ═══════════════════════════════════════════════════════════════════════════
//  НАСКОЛЬКО СИЛЬНО ЗАТЕМНЕНЫ ФОТОГРАФИИ ЗА ТЕКСТОМ
// ═══════════════════════════════════════════════════════════════════════════
//
// Одно место на весь сайт: и полосы в середине страниц, и фон блока туров,
// и фоны секций из SECTION_IMAGES.
//
// Значение — доля тёмного слоя поверх фотографии:
//   0    — фотография видна полностью (текст на ней читаться не будет);
//   0.6  — фотография хорошо видна, текст ещё читается;
//   0.9  — от фотографии остаётся лёгкая тень;
//   1    — фотографии не видно вообще.
//
// Три числа — верх, середина и низ фотографии. Середина светлее краёв:
// именно там кадр «дышит», а по краям он должен уходить в фон страницы.
// Если фото кажется тусклым — уменьшай `middle` шагом по 0.05.
export const PHOTO_VEIL = {
  top: 0.82,
  middle: 0.58,
  bottom: 0.9,
};

/** CSS-градиент вуали по значениям PHOTO_VEIL. Цвет берётся из палитры. */
export const veilGradient = (veil = PHOTO_VEIL) =>
  `linear-gradient(to bottom,
     rgb(var(--kj-dark) / ${veil.top}),
     rgb(var(--kj-dark) / ${veil.middle}) 50%,
     rgb(var(--kj-dark) / ${veil.bottom}))`;

export default SITE_IMAGES;
